import { useTabSessionState } from '../../hooks/useTabSessionState';

export interface UserProfile {
  id: string;
  phone: string | null;
  name: string;
  email: string | null;
}

export interface UserSession {
  token: string;
  user: UserProfile;
}

// 로그인 상태는 열려 있는 탭끼리 공유하되, 브라우저 창을 모두 닫으면 자동으로 로그아웃된다
export function useUserSession() {
  return useTabSessionState<UserSession | null>('userSession', null);
}

// 예전 버전에서 localStorage에 남겨둔 로그인 정보를 지워 창을 닫아도 로그인이 유지되던 문제를 정리한다
try {
  localStorage.removeItem('userSession');
} catch {
  // ignore
}
